import { render } from "./menu.vue?vue&type=template&id=3a716414&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=3a716414&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a716414"]])

export default __exports__